/* import __COLOCATED_TEMPLATE__ from './lsg-link-action.hbs'; */
import Component from '@ember/component';
import { stopClickEvent } from "../../utils/events";

/**
 * This is a link that will trigger an action rather than a normal browser navigation. Useful to not have to stop the click bubbling mainly.
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  tagName: 'a',
  classNames: ['LSG-c-lsg-link-action'],
  classNameBindings: ['isDisabled:LSG-c-lsg-link-action--disabled'],

  /**
   * Register services
   */

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  onClickAction: () => {
    throw new Error('no click action');
  },

  /*********************************
   * OPTIONAL PARAMS
   **********************************/

  /** @param {String} text The text to display (alternative to the slot method). */
  text: '',

  /**
   * @param {Boolean}     Set to true to disable the action link
   */
  isDisabled: false,

  /*********************************
   * LIFECYCLE FUNCTIONS
   **********************************/

  click(e) {
    stopClickEvent(e);

    if (this.get('isDisabled')) {
      return;
    }

    this.get('onClickAction')();
  }

  /*********************************
   * PRIVATE
   **********************************/

});
